import { Component } from '@angular/core';
import { TitleSectionComponent } from '../title-section.component';

@Component({
  selector: 'app-runtz-title-section',
  templateUrl: './runtz-title-section.component.html',
  standalone: false
})
export class RuntzTitleSectionComponent extends TitleSectionComponent {}
